import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { List } from 'immutable';
import { storeWithExpiration } from '../../utils/common';
import { fetchAccountPricingSettings, updateSettings } from '../../actions/pricing';
import AdminPricingSettingsForm from './AdminPricingSettingsForm';

const FORM_ID = 'adminPricingSettingsEditForm';

export class AdminPricingSettingsContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    fetchAccountPricingSettingsAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    updateSettingsAction: PropTypes.func.isRequired,
  };

  state = {
    isEdit: false,
  };

  componentWillMount = () => {
    const { fetchAccountPricingSettingsAction, accountId } = this.props;
    const token = storeWithExpiration.get('token');
    fetchAccountPricingSettingsAction(token, accountId);
  };

  componentWillReceiveProps = nextProps => {
    const { fetchAccountPricingSettingsAction, accountId } = nextProps;
    const token = storeWithExpiration.get('token');
    fetchAccountPricingSettingsAction(token, accountId);
  };

  performUpdateSettings = params => {
    const { updateSettingsAction, accountId } = this.props;
    const token = storeWithExpiration.get('token');
    let settingsInfo = new List();
    const revShareSettingsInfo = {
      accountSettingType: 'REV_SHARE',
      accountSettingValue: params.revShareVal,
      isDefault: false,
    };
    const pricingEnabledSettingsInfo = {
      accountSettingType: 'PRICING_ENABLED',
      accountSettingValue: params.pricingEnabledVal,
      isDefault: false,
    };
    settingsInfo = settingsInfo.push(revShareSettingsInfo);
    settingsInfo = settingsInfo.push(pricingEnabledSettingsInfo);
    settingsInfo.map(settingInfo => {
      updateSettingsAction(token, accountId, settingInfo);
      return false;
    });
    this.setState({ isEdit: false });
  };

  cancelForm = () => {
    this.setState({ isEdit: false });
  };

  toggleEdit = () => {
    const { isEdit } = this.state;

    if (isEdit) {
      this.setState({
        isEdit: false,
      });
    } else {
      this.setState({
        isEdit: true,
      });
    }
  };

  render() {
    const {
      handleSubmit,
      submitting,
      initialValues: { revShareVal, pricingEnabledVal },
      invalid,
    } = this.props;
    const { isEdit } = this.state;
    return revShareVal !== 0 ? (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card card-block rev-share">
              <p className="card-title">
                {isEdit ? null : (
                  <span>
                    <span>Rev Share: </span>
                    {revShareVal} &nbsp;
                    <span>Pricing: </span>
                    {pricingEnabledVal === 'true' ? 'Enabled' : 'Disabled'} &nbsp;
                    <button type="button" className="btn btn-primary" onClick={this.toggleEdit}>
                      Edit
                    </button>
                  </span>
                )}
              </p>
              {isEdit ? (
                <AdminPricingSettingsForm
                  invalid={invalid}
                  handleSubmit={handleSubmit}
                  submitting={submitting}
                  updateSettingsFunction={this.performUpdateSettings}
                  cancelFunction={this.cancelForm}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}

const validate = values => {
  const errors = {};
  if (!values.revShareVal || values.revShareVal === '') {
    errors.revShareVal = 'Required';
  } else if (!/^[01]\.\d{1,3}$/.test(values.revShareVal)) {
    errors.revShareVal = 'Invalid entry. Only numbers between 0 and 1 allowed';
  }
  if (!values.password || values.password === '') {
    errors.password = 'Required';
  }
  return errors;
};

function mapStateToProps(state) {
  const { priceBook } = state;
  const allSettings = priceBook.get('allSettings');
  const initialSettings = priceBook.get('initialSettings');
  const initialValues = {
    revShareVal: initialSettings.revShareVal,
    pricingEnabledVal: initialSettings.pricingEnabledVal,
  };
  return {
    allSettings,
    initialValues,
  };
}

const AdminPricingSettingsContainerRF = reduxForm({
  form: FORM_ID,
  validate,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(AdminPricingSettingsContainer);

export default connect(mapStateToProps, {
  fetchAccountPricingSettingsAction: fetchAccountPricingSettings,
  updateSettingsAction: updateSettings,
})(AdminPricingSettingsContainerRF);
